import React from 'react';
// mui components
import { ClickAwayListener, Grow, Paper, Popper, MenuList, Grid, Typography } from '@mui/material';

const PopperButtonNewUI = ({
  StyledMenuItem,
  width,
  items,
  activeItem,
  ButtonComponent,
  anchorRef,
  name,
  open,
  handleToggle,
  customPlacement,
  handleClose,
  handleListKeyDown,
  errorStyles,
  commonItemStyles,
  IconPlacement,
  className,
  popperStyles = {},
}) => {
  return (
    <>
      {React.cloneElement(ButtonComponent, {
        ref: anchorRef,
        id: `composition-button-${name}`,
        'aria-controls': open ? `composition-menu-${name}` : undefined,
        'aria-expanded': open ? 'true' : undefined,
        'aria-haspopup': 'true',
        onClick: handleToggle,
      })}

      <Popper
        transition
        open={open}
        role={undefined}
        placement={customPlacement}
        anchorEl={anchorRef.current}
        className={className}
        sx={{
          zIndex: 1301,
          background: '#fff',
          borderRadius: '12px',
          border: '1px solid #F3F4F9',
          ...popperStyles,
          //boxShadow: '0px 4px 10px rgba(35, 37, 47, 0.1), 1px 2px 2px rgba(35, 37, 47, 0.04)',
          '& .MuiPaper-root': {
            borderRadius: '12px',
          },
        }}
      >
        {({ TransitionProps, placement }) => (
          <Grow
            {...TransitionProps}
            style={{
              transformOrigin: placement === customPlacement ? 'right top' : 'right bottom',
            }}
          >
            <Paper
              sx={{
                width,
                '& .MuiList-root': {
                  padding: '2px',
                },
              }}
            >
              <ClickAwayListener onClickAway={handleClose}>
                <MenuList
                  autoFocusItem={open}
                  id={`composition-menu-${name}`}
                  aria-labelledby={`composition-button-${name}`}
                  onKeyDown={handleListKeyDown}
                >
                  {items.map(
                    ({ label, isErrorStyles, value, Icon, iconSize, color, onClick, hide }) => {
                      if (hide) return null;

                      const styles = Object.assign(
                        isErrorStyles ? errorStyles : {},
                        commonItemStyles
                      );

                      return (
                        <StyledMenuItem
                          key={label}
                          iconSize={iconSize}
                          disabled={!!activeItem && !!value && activeItem === value}
                          onClick={(event) => {
                            handleClose(event);
                            if (onClick) onClick();
                          }}
                          sx={styles}
                        >
                          {Icon && IconPlacement === 'start' && <Icon />}
                          {color ? (
                            <Grid container alignItems="center">
                              <Typography
                                component="span"
                                sx={{
                                  width: '18px',
                                  height: '18px',
                                  marginRight: '14px',
                                  borderRadius: '50%',
                                  backgroundColor: color,
                                  '& span': {
                                    color: '#000',
                                  },
                                }}
                              />
                              <span>{label}</span>
                            </Grid>
                          ) : (
                            label
                          )}
                          {Icon && IconPlacement === 'end' && <Icon />}
                        </StyledMenuItem>
                      );
                    }
                  )}
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </>
  );
};

export default PopperButtonNewUI;
